// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Nj2c","search":"styles_search__2SiNw","iconButton":"styles_iconButton__2XcWk"};